import { Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import RoundedButton from '@components/RoundedButton';

import { getObservationConfig } from '@constants/fhir';

import { useParameter } from '@hooks/useParameter';

const messages = defineMessages({
  title: {
    id: 'insights.parameter.title',
    defaultMessage: '{code} Parameters',
  },
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
  resetAll: {
    id: 'insights.parameter.resetAll',
    defaultMessage: 'Reset All',
  },
  confirmReset: {
    id: 'insights.parameter.delete.confirmReset',
    defaultMessage:
      'Are you sure you want to delete all the custom parameters for {code}?',
  },
  description: {
    id: 'insights.parameter.delete.description',
    title:
      "Deleting a patient's custom reference range resets it back to the default.",
  },
});

export default function Header() {
  const { formatMessage } = useIntl();
  const {
    code,
    handleFormSubmit,
    handleResetAllParameters,
    isStandard,
    loading,
  } = useParameter();
  const codeLabel = formatMessage({
    id: getObservationConfig(code)?.messageId,
  });

  return (
    <Stack
      alignItems="baseline"
      direction="row"
      justifyContent="space-between"
      sx={{
        width: '100%',
        mb: 2,
      }}
    >
      <Typography variant="h6">
        {formatMessage(messages.title, {
          code: codeLabel,
        })}
      </Typography>

      <Stack direction="row" spacing={2}>
        <ConfirmationDialog
          onConfirm={handleResetAllParameters}
          title={formatMessage(messages.confirmReset, {
            code: codeLabel,
          })}
          content={formatMessage(messages.description)}
        >
          {({ handleOpen }) => (
            <RoundedButton
              autoSize
              disabled={loading || isStandard}
              onClick={handleOpen}
              variant="white"
              width="auto"
            >
              {formatMessage(messages.resetAll)}
            </RoundedButton>
          )}
        </ConfirmationDialog>

        <RoundedButton
          disabled={loading}
          onClick={handleFormSubmit}
          type="submit"
          width="auto"
        >
          {formatMessage(messages.save)}
        </RoundedButton>
      </Stack>
    </Stack>
  );
}
